<!--========== 视频分析 ==========-->
<template>
    <div class="app-container">
        <el-card class="mb15" v-has-btn="'1,2,'">
            <el-row>
                <el-col :span="8" class="mb0">
                    <el-button v-has-btn="'1,2,'" type="primary" @click="handleCreate">新增教学分析</el-button>
                </el-col>
                <el-col :span="16" class="mb0">
                </el-col>
            </el-row>
        </el-card>
        <el-card>
            <el-form :model="queryParams" ref="queryForm" :inline="true" label-width="68px"
                     @submit.native.prevent="handleQuery">
                <el-row class="mt15">
                    <el-col :span="6" class="mb0">
                        <el-form-item label="学段">
                            <el-select @change="getList()" clearable v-model="queryParams.periodId" placeholder="请选择学段">
                                <el-option v-for="item in periodList" :key="item.id" :label="item.name"
                                           :value="item.id" />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6" class="mb0">
                        <el-form-item label="学科">
                            <el-select @change="getList()" clearable v-model="queryParams.subjectId" placeholder="请选择学科">
                                <el-option v-for="item in subjectList" :key="item.id" :label="item.title" :value="item.id" />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6" class="mb0">
                        <el-form-item label="状态">
                            <el-select @change="getList()" clearable v-model="queryParams.taskStatus" placeholder="请选择状态">
                                <el-option v-for="item in statusList" :key="item.value" :label="item.name" :value="item.value" />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6" class="mr0 mb0">
                        <el-form-item class="pull-right">
                            <el-input v-model="queryParams.taskName" placeholder="请输入视频名称" class="input-with-select">
                                <template #append>
                                    <el-button @click="handleQuery" type="primary" icon="el-icon-search" />
                                </template>
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <el-divider />
            <div class="bre9e mt10">
                <el-table header-cell-class-name="bgf2" show-overflow-tooltip
                          :height="`calc(100vh - 360px)`" v-loading="loading"
                          :data="dataList" highlight-current-row>
                    <el-table-column type="index" align="center" label="序号" width="60" />
                    <el-table-column width="80" align="center" label="状态" prop="taskStatus">
                        <template #default="scope">
                            <div v-if="scope.row.taskStatus === '0'">待分析</div>
                            <div v-if="scope.row.taskStatus === '1'">分析中</div>
                            <div v-if="scope.row.taskStatus === '2'">已分析</div>
                            <div v-if="scope.row.taskStatus === '-1'">分析失败</div>
                        </template>
                    </el-table-column>
                    <el-table-column width="100" align="center" label="授课教师" prop="trueName">
                    </el-table-column>
                    <el-table-column width="240" align="center" label="视频名称" prop="taskName">
                        <template #default="scope">
                            <div :title="scope.row.taskName" style="color: #409efe;" class="text-one cursor">
                                {{ scope.row.taskName }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column width="80" align="center" label="学段" prop="periodName">
                    </el-table-column>
                    <el-table-column width="80" align="center" label="学科" prop="subjectName">
                    </el-table-column>
                    <el-table-column width="240" align="center" label="量表" prop="scaleName">
                    </el-table-column>
                    <el-table-column width="140" align="center" label="分析时间" prop="Time">
                        <template #default="scope">
                            <div>{{ timestampToTime(scope.row.createTime)}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column width="100" align="center" fixed="right" label="操作">
                        <template #default="scope">
                            <el-popover placement="bottom" trigger="click" :width="100"
                                        popper-style="padding: 5px 0 0">
                                <template #reference>
                                    <el-button>操作</el-button>
                                </template>
                                <template #default>
                                    <div>
                                        <div class="text-item" v-if="scope.row.taskType===1&&scope.row.taskStatus==='2'">
                                            <el-text type="primary"  @click="handleReportInfo(scope.row)">查看</el-text>
                                        </div>
                                        <div class="text-item" v-if="scope.row.taskType===2&&scope.row.taskStatus==='2'">
                                            <el-text type="primary"  @click="handleYXReportInfo(scope.row)">查看</el-text>
                                        </div>
                                        <el-popconfirm confirm-button-text="是" cancel-button-text="否"
                                                       icon-color="#626AEF" title="确定删除该课题" @confirm="handleDelete(scope.row)">
                                            <template #reference>
                                                <div class="text-item" v-has-btn="'1,2,'">
                                                    <el-text type="primary" >删除</el-text>
                                                </div>
                                            </template>
                                        </el-popconfirm>
                                    </div>
                                </template>
                            </el-popover>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="zdyfy">
                <pagination class="zdyfy" :background="false" :pageSizes="[10, 20, 30]" :total="total"
                            :page.sync="queryParams.pageNum" :limit.sync="queryParams.pageSize" @pagination="getList" />
            </div>
        </el-card>
    </div>
</template>

<script>
import { timestampToTime } from "@/utils/date";
import { serviceUrl } from "@/utils/global"
import {listPeriod, listSubject,pageCourseTask,delCourseTask} from "@/api/admin/courseAnalyse";

export default {
    name: "index",
    components: {
    },
    data() {
        return {
            serviceUrl,
            role: this.$storage.get("role"),
            token: this.$storage.get("token"),
            userId: JSON.parse(this.$storage.get("userInfo")).userId,
            timestampToTime,
            periodList: [],
            subjectList: [],
            // 遮罩层
            loading: false,
            queryParams:{
                pageNum: 1,
                pageSize: 10,
                taskName: '',
                periodId: '',
                subjectId: '',
                taskStatus: '',
            },
            // 总条数
            total: 0,
            dataList: [],
            statusList: [
                { name: '待分析', value: '0' },
                { name: '分析中', value: '1' },
                { name: '已分析', value: '2' },
                { name: '分析失败', value: '-1' },
            ],

        };
    },
    created() {
        this.queryPeriodList();
        this.querySubjectList();
        this.getList()
    },
    activated() {
    },
    watch: {
    },
    methods: {
        handleCreate(){
            this.$router.push({
                path: "/courseAnalyseCreate",
            });
        },
        handleQuery(){
            this.getList();
        },
        getList(e){
            this.loading = true
            this.dataList = [];
            if (e) {
                this.queryParams.pageNum = e.page;
                this.queryParams.pageSize = e.limit;
            }
            this.loading = true;
            pageCourseTask(this.queryParams).then(res => {
                if (res.data.code===1){
                    this.total = res.data.data.total;
                    this.dataList = res.data.data.list;
                }else {
                    this.$message.error(res.data.msg);
                }
                this.loading = false;
            })
        },
        queryPeriodList(){
            listPeriod().then(res => {
                if (res.data.code===1){
                    this.periodList = res.data.data;
                }else {
                    this.$message.error(res.data.msg);
                }
            })
        },
        querySubjectList(){
            listSubject().then(res => {
                if (res.data.code===1){
                    this.subjectList = res.data.data;
                }else {
                    this.$message.error(res.data.msg);
                }
            })
        },
        handleDelete(row){
            delCourseTask({ taskId: row.taskId }).then(res => {
                if (res.data.code===1){
                    this.$message.success("删除成功");
                    this.getList()
                }else {
                    this.$message.error(res.data.msg);
                }
            })
        },
        handleReportInfo(row){
            this.$router.push({
                path: "/analyseReport",
                query: {
                    taskId: row.taskId,
                }
            });
        },
        handleYXReportInfo(row){
            this.$router.push({
                path: "/analyseReportInfo",
                query: {
                    taskId: row.taskId,
                }
            });
        },
    }

};
</script>
<style scoped>

.meeting-form .el-input {
    --el-input-width: 160px;
}
.meeting-form .el-date-editor {
    --el-date-editor-width: 150px;
}















.zdylesson /deep/ .el-dialog__body {
    padding-top: 0px !important;
}

.avatar-uploader .avatar {
    width: 270px;
    height: 152px;
    display: block;
    object-fit: cover;
}

.avatar-uploader /deep/ .el-upload {
    border: 1px dashed var(--el-border-color);
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    transition: var(--el-transition-duration-fast);
}

.avatar-uploader .el-upload:hover {
    border-color: var(--el-color-primary);
}

.el-icon.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 270px;
    height: 152px;
    text-align: center;
}

/deep/ .el-input-group__append {
    background: var(--el-color-primary);
    color: #fff;
}

.csbbb {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    padding: 0 15px;
}

.zdp /deep/ .el-range-editor.el-input__wrapper {
    width: 100%;
}

.zzzdddyyy /deep/ .el-upload-list {
    margin: 0 !important;
}

.zzzdddyyy /deep/ .el-upload-list__item {
    display: none;
}

.pxbutton {
    width: 90px;
    padding: 7px 15px;
    text-align: center;
    cursor: pointer;
    border: 1px solid #e4e7ed;
    font-size: 13px;
}

.filtxt {
    color: #409efe;
    margin: 8px 0;
}

.avatar-uploader .avatar {
    width: 270px;
    height: 152px;
    display: block;
    object-fit: cover;
}

.avatar-uploader /deep/ .el-upload {
    border: 1px dashed var(--el-border-color);
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    transition: var(--el-transition-duration-fast);
}

.avatar-uploader .el-upload:hover {
    border-color: var(--el-color-primary);
}

.el-icon.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 270px;
    height: 152px;
    text-align: center;
}

.el-table /deep/ .hidden-row {
    display: none;
}

.text-item {
    height: 45px;
    margin: 0 10px;
    text-align: center;
    padding: 10px;
    border-bottom: 1px solid lightgray;
    box-sizing: border-box;
}

.text-item .el-text {
    color: #606266;
    cursor: pointer;
    user-select: none;
}

.text-item:last-child {
    border: none;
}
</style>
